export const RESET_CART_ISFETCHING = 'RESET_CART_ISFETCHING';
export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_HOSTED_PAYMENT_REQUEST =
  'GET_CART_HOSTED_PAYMENT_REQUEST';
export const GET_CART_REQUESTING = 'GET_CART_REQUESTING';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';

export const ADD_CART_ITEM_REQUEST = 'ADD_CART_ITEM_REQUEST';
export const ADD_CART_QUICK_ITEM_REQUEST = 'ADD_CART_QUICK_ITEM_REQUEST';
export const ADD_CART_ITEM_SUCCESS_GTM = 'ADD_CART_ITEM_SUCCESS_GTM';
export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST';
export const REMOVE_CART_ITEM_SUCCESS_GTM = 'REMOVE_CART_ITEM_SUCCESS_GTM';
export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';

export const UPDATE_CART_REQUEST = 'UPDATE_CART_REQUEST';
export const UPDATE_AND_CHARGE_CART_REQUEST = 'UPDATE_AND_CHARGE_CART_REQUEST';
export const UPDATE_CART_AND_SAVE_SHIPPING_ADDRESS_REQUEST =
  'UPDATE_CART_AND_SAVE_SHIPPING_ADDRESS_REQUEST';
export const CHARGE_CART_REQUEST = 'CHARGE_CART_REQUEST';
export const CHARGE_CART_SUCCESS_GTM = 'CHARGE_CART_SUCCESS_GTM';

export const SIDE_CART_VISIBLE = 'SIDE_CART_VISIBLE';
export const SIDE_CART_NOT_VISIBLE = 'SIDE_CART_NOT_VISIBLE';

export const ADD_COUPON_OR_GIFTCARD_REQUEST = 'ADD_COUPON_OR_GIFTCARD_REQUEST';
export const ADD_COUPON_OR_GIFTCARD_SUCCESS_GTM =
  'ADD_COUPON_OR_GIFTCARD_SUCCESS_GTM';

export const CHECKOUT_STEP_REQUEST_GTM = 'CHECKOUT_STEP_REQUEST_GTM';
export const CHECKOUT_STEP_REQUEST = 'CHECKOUT_STEP_REQUEST';

export const SEND_CART_TO_HOSTED_PAYMENT_REQUEST =
  'SEND_CART_TO_HOSTED_PAYMENT_REQUEST';

export const UPDATE_AND_CHARGE_CART_PAYGATE_REQUEST =
  'UPDATE_AND_CHARGE_CART_PAYGATE_REQUEST';
